import {apiFetch as fetch} from "../../../../apiClient";

export const placeKiteOrder = async (orderPayload) => {
    const res = await fetch('/api/kite-orders/place', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderPayload)
    });

    return await res.json();
    // { success, message, orderId }
};